routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.compare', {
      url: __env.routes.compare,
      params: {
        products: {
          array: true
        }
      },
      template: `<compare-products sh-ctrl="shCtrl"></compare-products>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/catalog/compare-products/compare-products.config.js